// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import less from 'less'


import './common/common.js'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import './element-variables.scss'
Vue.use(Element)

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(less)

// 引入公用JS函数
import * as util from './common/util.js'
Vue.prototype.$util = util

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js